/**
 * Users API Layer
 * Hanterar all kommunikation med backend för användarhantering
 */

import { API_URL, authHeaders } from '../../../utils/api';

/**
 * Hämtar alla leverantörer från backend
 * @returns {Promise<Array>} Lista med leverantörer
 */
export const fetchSuppliers = async () => {
  try {
    const response = await fetch(`${API_URL}/suppliers`, { headers: authHeaders() });
    if (!response.ok) {
      throw new Error('Kunde inte hämta leverantörer');
    }
    return await response.json();
  } catch (error) {
    console.error('Fel vid hämtning av leverantörer:', error);
    throw error;
  }
};

/**
 * Skickar välkomstmail till ny användare
 * @param {Object} user - Användarobjekt
 * @param {string} password - Användarens lösenord
 * @returns {Promise<Object>} Resultat från mail-operationen
 */
export const sendWelcomeEmail = async (user, password) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}/api/mail/send-welcome-email`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user, password }),
    });
    
    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.message || 'Kunde inte skicka välkomstmail');
    }
    
    return result;
  } catch (error) {
    console.error('Fel vid skickande av välkomstmail:', error);
    throw error;
  }
};

